import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { ContratoCliente, ContratoClienteBusca, ContratoDashboard, ContratoProdutoBusca } from '../../models/contratos/contrato';

@Injectable({
  providedIn: 'root'
})
export class ContratoService {
  private baseUrl: string;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(
    private http: HttpClient,
    @Inject('BASE_URL') baseUrl: string,
    private toastr: ToastrService
  ) {
    this.baseUrl = baseUrl;
  }

  getContratos(): Observable<ContratoCliente[]> {
    return this.http.post<ContratoCliente[]>(this.baseUrl + 'api/Contratos/GetContratos', this.basePayload(), { headers: this.headers })
      .pipe(catchError(() => {
        this.toastr.error('', 'Houve um erro ao carregar contratos.');
        return of([]);
      }));
  }

  getContrato(id: number): Observable<ContratoCliente> {
    return this.http.post<ContratoCliente>(this.baseUrl + 'api/Contratos/GetContrato', {
      ...this.basePayload(),
      id
    }, { headers: this.headers }).pipe(catchError(() => of(null)));
  }

  saveContrato(contrato: ContratoCliente): Observable<number> {
    const payload = {
      ...contrato,
      data_fim: contrato.data_fim && contrato.data_fim !== '' ? contrato.data_fim : null,
      guidclientenapis: this.guid(),
      seller_id_usuario: this.sellerId()
    };

    return this.http.post<number>(this.baseUrl + 'api/Contratos/SaveContrato', {
      contrato: payload
    }, { headers: this.headers }).pipe(catchError(() => {
      this.toastr.error('', 'Houve um erro ao salvar contrato.');
      return of(0);
    }));
  }

  deleteContrato(id: number): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + 'api/Contratos/DeleteContrato', {
      ...this.basePayload(),
      id
    }, { headers: this.headers }).pipe(catchError(() => of(false)));
  }

  searchClients(termo: string): Observable<ContratoClienteBusca[]> {
    return this.http.post<ContratoClienteBusca[]>(this.baseUrl + 'api/Contratos/SearchClients', {
      ...this.basePayload(),
      termo
    }, { headers: this.headers }).pipe(catchError(() => of([])));
  }

  searchProducts(termo: string): Observable<ContratoProdutoBusca[]> {
    return this.http.post<ContratoProdutoBusca[]>(this.baseUrl + 'api/Contratos/SearchProducts', {
      guidclientenapis: this.guid(),
      termo
    }, { headers: this.headers }).pipe(catchError(() => of([])));
  }

  getDashboard(filtro: any = {}): Observable<ContratoDashboard> {
    return this.http.post<ContratoDashboard>(this.baseUrl + 'api/Contratos/GetDashboard', {
      ...this.basePayload(),
      ...filtro
    }, { headers: this.headers }).pipe(catchError(() => {
      this.toastr.error('', 'Houve um erro ao carregar dashboard de contratos.');
      return of({ contratos_ativos: 0, linhas: [], meta_mes_atual: 0, realizado_mes_atual: 0, atingimento_mes_atual: 0 });
    }));
  }

  private basePayload(): any {
    return {
      guidclientenapis: this.guid(),
      seller_id: this.sellerId()
    };
  }

  private guid(): string {
    return localStorage.getItem('guidclientenapis');
  }

  private sellerId(): number {
    return parseInt(localStorage.getItem('id'), 10);
  }
}
